
import { defineComponent } from "vue";
import { IonPage, IonContent, IonItem, IonLabel, IonText, getPlatforms } from "@ionic/vue";

export default defineComponent({
  components: { IonPage, IonContent, IonItem, IonLabel, IonText },

  setup() {
    const platforms = (): string => {
      return getPlatforms().join();
    };

    return {
      platforms,
    };
  },
});
